import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useDrawer } from 'hooks/drawer.hook';
import { DRAWERS } from 'utils/constants';
import { setModalStatus } from 'redux/slices/modal.slice';
import { wellnub } from 'network/wellnub.api';

const mutationFn = async id => {
  const { data } = await wellnub.patch(
    `/v1/client/wellnubService/nutritionistAppointment/cancel/${id}`,
  );
  return data;
};

export const useCancelNutritionistAppointmentService = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { handleClose } = useDrawer(DRAWERS.nutritionistAppointment);

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('GET_VIRTUAL_AGENDA_APPOINTMENTS');
      queryClient.invalidateQueries('GET_APPOINTMENTS_WITH_NUTRITIONIST');
      enqueueSnackbar('Se canceló correctamente la cita con tu nutriologo', {
        variant: 'success',
      });
    },
    onError: ({ response }) => {
      if (response?.data?.isPublic) {
        enqueueSnackbar(response?.data?.message, { variant: 'warning' });
      } else {
        enqueueSnackbar('Algo salió mal, intenta de nuevo más tarde', {
          variant: 'error',
        });
      }
    },
    onSettled: () => {
      handleClose();
      dispatch(
        setModalStatus({
          name: 'NUTRITIONIST_APPOINTMENT_CONFIRMATION',
          isActive: false,
        }),
      );
    },
  });
};
